import { fetchGating } from "actions/gating";
import { fetchPage } from "actions/pages";
import { useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import shortid from 'shortid';
const IMAGE_CDN_ENDPOINT = process.env.NEXT_PUBLIC_IMAGE_CDN;

export const useWidgetContext = ({ desktop, personalizationId, segmentId, page, domainUrl, storyboard }) => {
  const dispatch = useDispatch()
  const editorSession = `editors_${page.id}`
  
  const [widgetContextState, setWidgetContextState] = useState({
    session: `editors_${page.id}`,
    selector: `editors_${page.id}.present`,
    breakpoint: desktop ? 'desktop' : 'mobile',
    imageCDN: IMAGE_CDN_ENDPOINT,
    shouldZoom: true,
    preview: true,
    development: false,
    storyboard,
    domain: domainUrl,
    createLiveElementContext: (element) => {
      const sessionId = `editors_live_element_${element.uid}`;
      return {
        ...widgetContextState,
        session: sessionId,
        selector: `${sessionId}.present`
      }
    },
    createGatingContext: (gating) => {
      const sessionId = `editors_gating_${gating}`;

      return {
        ...widgetContextState,
        session: sessionId,
        selector: `${sessionId}.present`
      }
    },
    fetchGating: (gating) => {
      dispatch(fetchGating(gating, true));
    },
    fetchPage: (id) => {
      dispatch(fetchPage(id, true, personalizationId, segmentId));
    },
    updateCarouselSlide: (payload) => {
      setWidgetContextState(prev => ({
        ...prev,
        carouselSlide: payload
      }));
    }
  });

  return { widgetContextState, setWidgetContextState, editorSession }
};
